/**
 * Select — bordered native select, terminal-style.
 *
 * Native `<select>` on purpose: a) accessible by default, b) we don't
 * need a custom popover (no rich options) and c) keeps bundle slim.
 */
import { forwardRef, type SelectHTMLAttributes } from 'react'
import { cn } from '@/lib/cn'

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  function Select({ className, invalid, children, ...rest }, ref) {
    return (
      <select
        ref={ref}
        className={cn(
          'block w-full h-9 px-3 pr-8 text-sm rounded',
          'bg-elevated text-text',
          'border border-line hover:border-lineHi',
          'focus:outline-none focus:border-fire focus:ring-0',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          'appearance-none bg-no-repeat bg-right',
          invalid && 'border-rose focus:border-rose',
          className,
        )}
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='%238893A4' d='M0 0l5 6 5-6z'/></svg>\")",
          backgroundPosition: 'right 10px center',
        }}
        {...rest}
      >
        {children}
      </select>
    )
  },
)
